export const ICONS = [
    'add',
    'administration',
    'alert-sharp',
    'alert',
    'arrow-left',
    'arrow-right',
    'back',
    'calendar',
    'cancel-circle',
    'check-circle',
    'check',
    'check2',
    'check3',
    'checkmark',
    'chevron-down',
    'chevron-right',
    'chevron-up',
    'circle',
    'close',
    'copy',
    'date-picker',
    'delete',
    'density',
    'document',
    'done-all',
    'dot',
    'double-arrow-up',
    'double-checkmark',
    'download',
    'edit',
    'failure',
    'flag-circle',
    'ge-aerospace',
    'ge',
    'health-no-data',
    'help',
    'inbox',
    'info',
    'keyboard-arrow-down',
    'keyboard-arrow-up',
    'message',
    'module-settings',
    'next',
    'pending',
    'person-outline',
    'report',
    'send-circle',
    'status-cancel',
    'stop',
    'submitted',
    'syncing',
    'upload-circle',
    'upload-done',
    'upload',
    'user',
    'warning',
    'warning-circle',
];
